import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { integrationSchemaRegistry } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { GithubService } from '../../service';

export type BranchProtectionRulesConfig = typeof BranchProtectionRulesConfig._.Config;

export enum BPRConfigParameter {
  AllowsDeletions = 'allowsDeletions',
  AllowsForcePushes = 'allowsForcePushes',
  BlocksCreations = 'blocksCreations',
  DismissesStaleReviews = 'dismissesStaleReviews',
  IsAdminEnforced = 'isAdminEnforced',
  LockBranch = 'lockBranch',
  RequireLastPushApproval = 'requireLastPushApproval',
  RequiresApprovingReviews = 'requiresApprovingReviews',
  RequiresCodeOwnerReviews = 'requiresCodeOwnerReviews',
  RequiresCommitSignatures = 'requiresCommitSignatures',
  RequiresConversationResolution = 'requiresConversationResolution',
  RequiresDeployments = 'requiresDeployments',
  RequiresLinearHistory = 'requiresLinearHistory',
  RequiresStatusChecks = 'requiresStatusChecks',
  RequiresStrictStatusChecks = 'requiresStrictStatusChecks',
  RestrictsPushes = 'restrictsPushes',
  RestrictsReviewDismissals = 'restrictsReviewDismissals',
}

export const BranchProtectionRulesConfig = IntegrationConfig.make({
  service: GithubService,
  name: Integration_Handler_Names_Enum.BranchProtectionRules,
  configSchema: z.object({
    repoName: z.string().min(1),
    rulePattern: z.string().min(1),
    requiredConfigs: z
      .array(
        z.enum(BPRConfigParameter).register(integrationSchemaRegistry, {
          i18n: 'integrations.github.services.github.shared.bpr_config_parameter',
        }),
      )
      .optional(),
    minimumRequiredApprovals: z.coerce.number().min(0).optional(),
  }),
});
